import React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { colors } from "@mui/material";
import successImg from "../../assets/images/userprofile/successImg.png";
import { Matchmakers } from "../matchmakers";
import { axiosInstance_agent } from "../../axiosInstance-agent";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};

const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "application/pdf"];

const validationSchema = Yup.object({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  // profile_pic: Yup.mixed()
  //   .required("Profile picture is required")
  //   .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
  //     value ? SUPPORTED_FORMATS.includes(value.type) : false
  //   ),
  // document: Yup.mixed()
  //   .required("Document is required")
  //   .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
  //     value ? SUPPORTED_FORMATS.includes(value.type) : false
  //   ),
});

export function MatchmakerAddProfile() {
  const [loader, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [imageNames, setImageNames] = useState("Browse");
  const navigate = useNavigate();

  function handleImageChange(event) {
    const file = event.target.files[0];
    if (file) {
      setImageNames(file.name);
    } else {
      setImageNames("Browse");
    }
  }

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      agency_name: "",
      profile_pic: null,
      document: null,
      category: "Match Maker",
      about: "",
      terms_condition: "",
      account_number: "",
      ifsc_code: "",
      bank: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const formData = new FormData();
        for (const key in values) {
          formData.append(key, values[key]);
        }

        console.log("📤 Sending FormData:");
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }

        const response = await axiosInstance_agent.post(
          "/Agent/register",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        console.log("✅ Submitted:", response.data);
        toast.success("Form data successfully Submitted");
        setLoading(false);
        handleOpen();
        setTimeout(() => {
          handleClose();
          navigate("/matchmakers");
        }, 2000);
        formik.resetForm();
      } catch (error) {
        console.error("❌ Error:", error);
        setLoading(false);
        toast.error(
          error.response.data.message || "Submission failed. Please try again."
        );
      }
    },
  });

  return (
    <div>
      {loader && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div className="matchEdit-subcontainer">
        <Link to="/matchmakers">
          <div className="bi bi-arrow-left"></div>
        </Link>

        <div className="matchAdd-menu">
          <div>Basic Information</div>
        </div>
      </div>

      {/* content */}
      <div className="MatchMainContainer">
        <form onSubmit={formik.handleSubmit}>
          <div>
            {/* row1 */}
            <div className="MatchSubcontainer">
              <div>
                <div className="match-lableName">
                  First Name <span className="text-danger">*</span>
                </div>
                <div className="matchTextbox">
                  <input
                    type="text"
                    name="first_name"
                    placeholder="Enter First Name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.first_name}
                  />
                  {formik.touched.first_name && formik.errors.first_name && (
                    <div className="error">{formik.errors.first_name}</div>
                  )}
                </div>
              </div>

              <div>
                <div className="match-lableName">
                  Last Name <span className="text-danger">*</span>
                </div>
                <div className="matchTextbox">
                  <input
                    type="text"
                    name="last_name"
                    placeholder="Enter Last Name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.last_name}
                  />
                  {formik.touched.last_name && formik.errors.last_name && (
                    <div className="error">{formik.errors.last_name}</div>
                  )}
                </div>
              </div>
            </div>
            {/* row2 */}
            <div className="MatchSubcontainer">
              <div>
                <div className="match-lableName">User Image</div>
                <div className="matchTextbox">
                  <label
                    htmlFor="profile_pic_input"
                    className="custom-file-label"
                  >
                    {formik.values.profile_pic?.name || "Browse"}
                  </label>
                  <input
                    type="file"
                    id="profile_pic_input"
                    className="custom-file-input"
                    accept="image/*"
                    name="profile_pic"
                    onChange={(event) => {
                      formik.setFieldValue(
                        "profile_pic",
                        event.currentTarget.files[0]
                      );
                    }}
                  />
                  {formik.touched.profile_pic && formik.errors.profile_pic && (
                    <div className="error">{formik.errors.profile_pic}</div>
                  )}
                </div>
              </div>
              <div>
                <div className="match-lableName">
                  Email <span className="text-danger">*</span>
                </div>
                <div className="matchTextbox">
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter Email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="error">{formik.errors.email}</div>
                  )}
                </div>
              </div>
            </div>
            {/* row3 */}
            <div className="MatchSubcontainer">
              <div>
                <div className="match-lableName">
                  Mobile Number <span className="text-danger">*</span>
                </div>
                <div className="matchTextbox">
                  <input
                    type="number"
                    name="mobile"
                    onChange={formik.handleChange}
                    value={formik.values.mobile}
                    maxLength={10}
                  />
                  {formik.touched.mobile && formik.errors.mobile && (
                    <div className="error">{formik.errors.mobile}</div>
                  )}
                </div>
              </div>
              <div>
                <div className="match-lableName">Agency Name</div>
                <div className="matchTextbox">
                  <input
                    type="text"
                    name="agency_name"
                    onChange={formik.handleChange}
                    value={formik.values.agency_name}
                  />
                </div>
              </div>
            </div>
            {/* row4 */}
            <div className="MatchSubcontainer">
              <div>
                <div className="match-lableName">
                  Aadhar or Pancard Document{" "}
                </div>
                <div className="matchTextbox">
                  <label htmlFor="document_input" className="custom-file-label">
                    {formik.values.document?.name || "Browse"}
                  </label>
                  <input
                    type="file"
                    id="document_input"
                    className="custom-file-input"
                    accept="image/*"
                    name="document"
                    onChange={(event) => {
                      formik.setFieldValue(
                        "document",
                        event.currentTarget.files[0]
                      );
                    }}
                  />
                  {formik.touched.document && formik.errors.document && (
                    <div className="error">{formik.errors.document}</div>
                  )}
                </div>
              </div>
            </div>
            {/* row 5  */}
            <div className="MatchSubcontainer">
              <div>
                <div className="match-lableName">About</div>
                <div className="matchTextbox">
                  <textarea
                    name="about"
                    onChange={formik.handleChange}
                    value={formik.values.about}
                    rows={4}
                  />
                  {formik.touched.about && formik.errors.about && (
                    <div className="error">{formik.errors.about}</div>
                  )}
                </div>
              </div>
              <div>
                <div className="match-lableName">Terms & Conditions</div>
                <div className="matchTextbox">
                  <textarea
                    name="terms_condition"
                    onChange={formik.handleChange}
                    value={formik.values.terms_condition}
                    rows={4}
                  />
                </div>
              </div>
            </div>
            {/* row 6  */}
            <div className="MatchSubcontainer">
              <div>
                <div className="match-lableName">Bank Account Number</div>
                <div className="matchTextbox">
                  <input
                    type="number"
                    name="account_number"
                    onChange={formik.handleChange}
                    value={formik.values.account_number}
                  />
                  {formik.touched.account_number &&
                    formik.errors.account_number && (
                      <div className="error">
                        {formik.errors.account_number}
                      </div>
                    )}
                </div>
              </div>
              <div>
                <div className="match-lableName">IFSC Code</div>
                <div className="matchTextbox">
                  <input
                    type="text"
                    name="ifsc_code"
                    onChange={formik.handleChange}
                    value={formik.values.ifsc_code}
                  />
                </div>
              </div>
              <div>
                <div className="match-lableName">Bank Name</div>
                <div className="matchTextbox">
                  {/* <input
                    type="text"
                    name="bank"
                    onChange={formik.handleChange}
                    value={formik.values.bank}
                 
                  /> */}
                  <select
                    name="bank"
                    onChange={formik.handleChange}
                    value={formik.values.bank}
                  >
                    <option value="">Select Bank</option>
                    <option value="Union Bank of India">
                      Union Bank of India
                    </option>
                    <option value="UCO Bank">UCO Bank</option>
                    <option value="State Bank of India">
                      State Bank of India
                    </option>
                    <option value="Punjab National Bank">
                      Punjab National Bank
                    </option>
                    <option value="Canara Bank">Canara Bank</option>
                    <option value="Bank of Maharashtra">
                      Bank of Maharashtra
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="btnMakerAddSave">
            <Button type="submit" disabled={loader}>
              {loader ? "Saving..." : "Save"}
            </Button>
          </div>
        </form>

        <div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose} //close modal on background click
            closeAfterTransition
          >
            <Fade in={open}>
              <Box sx={style} className="modal-box">
                <img srcSet={successImg} />
                <Typography
                  id="transition-modal-title"
                  variant="h6"
                  component="h2"
                >
                  Thank You
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  The profile has been successfully updated
                </Typography>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </div>
  );
}
